import { createRoot, createSignal, type JSX, type JSXElement } from 'solid-js'
import { createStore } from 'solid-js/store'
import { invalidateBalance, setBalance } from '~/resources/currency'

export const rewardDialog = createRoot(() => {
  const [item, setItem] = createSignal<null | {
    type: 1 | 2
    title: string
    amount: number | null
    icon: string | JSX.Element
  }>(null)

  return {
    item,
    setItem,
    close: () => setItem(null),
  }
})

export type GeneralItem = (
  | {
      type: 'coin' | 'gem'
      amount: number
    }
  | {
      type: 'tree'
      title: string
      gid: number
    }
  | {
      type: 'sound'
      title: string
      gid: number
    }
  | {
      type: 'coupon'
    }
) & {
  icon: string | JSX.Element
}

export type FallbackItem = {
  type: 'fallback'
  from: GeneralItem
  fallback: GeneralItem
}

export type Item = GeneralItem | FallbackItem

const [state, setState] = createStore({
  items: null as Item[] | null,
  currentIndex: -1,
  previewScene: null as JSXElement | null,
  isNextBtnLocked: true,
})

export const rewardFlow = {
  get items() {
    return state.items
  },
  get previewScene() {
    return state.previewScene
  },
  get current() {
    return state.items?.[state.currentIndex]
  },
  get isNextBtnLocked() {
    return state.isNextBtnLocked
  },
  start(items: Item[], previewScene?: JSXElement) {
    setState({
      items,
      currentIndex: 0,
      previewScene: previewScene ?? null,
    })
  },
  canNext() {
    setState('isNextBtnLocked', false)
  },
  next() {
    const index = state.currentIndex
    const items = state.items!
    // finish
    if (index === items.length - 1) {
      let coin = 0
      let gem = 0
      for (const item of items) {
        const resolved = item.type === 'fallback' ? item.fallback : item
        if (resolved.type === 'coin') coin += resolved.amount
        else if (resolved.type === 'gem') gem += resolved.amount
      }
      if (coin || gem) {
        setBalance((prev) => ({
          ...prev,
          coin: prev.coin + coin,
          gem: prev.gem + gem,
        }))
        invalidateBalance()
      }
      setState({
        items: null,
        currentIndex: -1,
        isNextBtnLocked: true,
      })
      return
    }
    // next item
    setState({
      currentIndex: index + 1,
      isNextBtnLocked: true,
    })
  },
  endPreviewScene() {
    setState('previewScene', null)
  },
}
